var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-sidenav'),_c('v-main',[_c('router-view',{on:{"raison-event":_vm.openSnackBar}})],1),_c('app-snackbar',{ref:"appSnackbar",attrs:{"type":_vm.snackbarType,"messages":_vm.snackbarMessages}}),_c('help-panel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }